import { Help as HelpIconMaterial } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTutorial } from "../hooks/useTutorial";
import { TutorialConfig } from "../types/tutorial";

interface HelpIconProps {
  tutorialConfig: TutorialConfig;
  pageDescription: string;
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary" | "default";
}

export const HelpIcon: React.FC<HelpIconProps> = ({ tutorialConfig, pageDescription, size = "small", color = "primary" }) => {
  const { startTutorial, hasSeenTutorial } = useTutorial();

  const handleHelpClick = () => {
    startTutorial(tutorialConfig);
  };

  return (
    <Tooltip
      title={
        <div>
          <div style={{ fontWeight: "bold", marginBottom: "4px" }}>Page Help</div>
          <div style={{ fontSize: "0.875rem" }}>{pageDescription}</div>
          <div style={{ fontSize: "0.75rem", marginTop: "4px", opacity: 0.8 }}>{hasSeenTutorial(tutorialConfig.id) ? "Click to restart tutorial" : "Click to start tutorial"}</div>
        </div>
      }
      arrow
      placement="bottom"
    >
      <IconButton
        onClick={handleHelpClick}
        size={size}
        color={color}
        sx={{
          opacity: 0.7,
          "&:hover": {
            opacity: 1,
          },
        }}
        data-tutorial="help-icon"
      >
        <HelpIconMaterial />
      </IconButton>
    </Tooltip>
  );
};
